import { render, staticRenderFns } from "./DeptManage.vue?vue&type=template&id=cf6c933e&scoped=true&"
import script from "./DeptManage.vue?vue&type=script&lang=js&"
export * from "./DeptManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6c933e",
  null
  
)

export default component.exports